import { useEffect, useState } from "react";
import {
  BrightcovePlaylistResponse,
  BrightcoveVideo,
} from "@components/Brightcove/utils/types";
import * as Sentry from "@sentry/react";
import axios from "axios";

const fetchBudget2024DrupalVideos = async (): Promise<BrightcoveVideo[]> => {
  const response = await axios.post<BrightcovePlaylistResponse>(
    "/_plat/api/v1/budget2024-videos"
  );

  return response.data || [];
};

export default function useBudget2024Videos(): BrightcoveVideo[] {
  const [data, setData] = useState<BrightcoveVideo[]>([]);

  useEffect(() => {
    const callFetch = async () => {
      setData(await fetchBudget2024DrupalVideos());
    };

    try {
      callFetch();
    } catch (error) {
      Sentry.captureException(error);
    }
  }, []);

  return data;
}
